import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ArrowRight, Mail, Phone } from "lucide-react";

const MidCTA = () => {
  const { t } = useTranslation();

  return (
    <section
      data-testid="midcta-section"
      className="relative py-20 md:py-28"
    >
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative overflow-hidden rounded-[2rem] electric-border"
          style={{
            background:
              "linear-gradient(135deg, rgba(255,45,92,0.18) 0%, rgba(155,77,255,0.12) 50%, rgba(61,191,255,0.18) 100%)",
            backdropFilter: "blur(20px)",
          }}
        >
          <div
            aria-hidden
            className="absolute -left-32 -top-32 h-[26rem] w-[26rem] rounded-full opacity-50 blur-3xl pulse-glow"
            style={{ background: "#FF2D5C" }}
          />
          <div
            aria-hidden
            className="absolute -bottom-40 -right-32 h-[28rem] w-[28rem] rounded-full opacity-50 blur-3xl pulse-glow"
            style={{ background: "#3DBFFF", animationDelay: "-2s" }}
          />

          <div className="relative grid gap-8 px-7 py-12 md:grid-cols-12 md:px-14 md:py-16">
            <div className="md:col-span-7">
              <span className="eyebrow">{t("midcta.eyebrow")}</span>
              <h3 className="font-display mt-4 text-xl sm:text-2xl md:text-[2rem] font-semibold leading-[1.12] text-white">
                {t("midcta.title")}
              </h3>
              <p className="mt-5 max-w-xl text-base md:text-lg text-white/75 leading-relaxed">
                {t("midcta.lead")}
              </p>
            </div>
            <div className="md:col-span-5 flex flex-col justify-center gap-3">
              <a
                href="mailto:ds@elektrouniversal.dk?subject=Future%20Football%20-%20Book%20et%20m%C3%B8de"
                data-testid="midcta-primary"
                className="group inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base btn-neon-primary"
              >
                <Mail className="h-4 w-4" />
                {t("midcta.primary")}
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="tel:+4560439162"
                data-testid="midcta-secondary"
                className="inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base btn-neon-ghost"
              >
                <Phone className="h-4 w-4" />
                {t("midcta.secondary")} · +45 60 43 91 62
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MidCTA;
